import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function Gallery() {
  const categories = [{
    eyebrow: "Recipes",
    name: "Get Creative",
    description: "Look for some inspiration and check out some of our own favourite recipes you can create with Pro-Whip ",
    image: {
      src: "https://prowhip.one/wp-content/uploads/2026/07/ChatGPT-Image-Jul-6-2026-05_19_14-PM.png?v=5m8rr23zkls",
      srcset: "https://prowhip.one/wp-content/uploads/2026/07/ChatGPT-Image-Jul-6-2026-05_19_14-PM.png?v=ew3z1ll9xet-wvc-srcset",
      sizes: "https://prowhip.one/wp-content/uploads/2026/07/ChatGPT-Image-Jul-6-2026-05_19_14-PM.png?v=rou3k6mkakl-wvc-sizes",
      alt: "High-quality whipped cream chargers arranged neatly"
    },
    to: "/InquiryPage"
  }, {
    eyebrow: "World Cup 2026",
    name: "Limited Time",
    description: "Who are you rooting for? Our new World Cup 2026 Edition is now Available for a limited time!",
    image: {
      src: "https://prowhip.one/wp-content/uploads/2026/07/ChatGPT-Image-Jul-6-2026-04_20_34-PM-1.png?v=m2fqo0yu4g",
      srcset: "https://prowhip.one/wp-content/uploads/2026/07/ChatGPT-Image-Jul-6-2026-04_23_25-PM.png?v=d8pooug1ade-wvc-srcset",
      sizes: "https://prowhip.one/wp-content/uploads/2026/07/ChatGPT-Image-Jul-6-2026-04_23_25-PM.png?v=x0zuobbvhh-wvc-sizes",
      alt: "Professional stainless steel whipped cream dispenser"
    },
    to: "/InquiryPage"
  }, {
    eyebrow: "COMING SOON",
    name: "Spooky Season",
    description: "The Team at ProWhip are currently busy creating some new 'Thrilling'  flavours. Coming soon...",
    image: {
      src: "https://prowhip.one/wp-content/uploads/2026/07/ChatGPT-Image-Jul-6-2026-04_23_25-PM.png?v=hbm060ci7nv",
      srcset: "https://prowhip.one/wp-content/uploads/2026/07/ChatGPT-Image-Jul-6-2026-04_23_25-PM.png?v=3nsh99l44g5-wvc-srcset",
      sizes: "https://prowhip.one/wp-content/uploads/2026/07/ChatGPT-Image-Jul-6-2026-04_23_25-PM.png?v=7fm2o49cmdq-wvc-sizes",
      alt: "Assorted nozzles and cleaning brushes for dispensers"
    },
    to: "/InquiryPage"
  }];
  return <section data-section-id="3268" id="seasonaldropsgallery" className="bg-background text-foreground py-24 md:py-32 lg:py-40">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="mb-16 md:mb-20 lg:mb-24 max-w-3xl">
          <p className="font-default text-xs uppercase tracking-[0.25em] text-primary mb-6">
            — Our Product Range
          </p>
          <h2 className="font-default font-bold text-foreground text-4xl md:text-5xl lg:text-[3rem] leading-[1.05] tracking-tight">
            Professional culinary solutions.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {categories.map((category, i) => <Link key={i} data-index={i} to={category.to} className="group block cursor-pointer">
              <div className="relative overflow-hidden rounded-lg shadow-md">
                <div className="relative w-full" style={{
              paddingTop: "133.33%"
            }}>
                  <img src={category.image.src} data-wvc-srcset={category.image.srcset} data-wvc-sizes={category.image.sizes} alt={category.image.alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]" />
                  <div className="absolute inset-0 bg-primary/0 transition-colors duration-700 ease-out group-hover:bg-primary/10" />
                </div>
              </div>

              <div className="pt-8 md:pt-10">
                <p className="font-default text-[0.7rem] uppercase tracking-[0.25em] text-primary mb-4">
                  {category.eyebrow}
                </p>
                <h3 className="font-default font-bold text-foreground text-3xl md:text-[2.5rem] leading-[1.05] tracking-tight mb-3">
                  {category.name}
                </h3>
                <p className="font-default text-base text-muted-foreground mb-6 leading-relaxed">
                  {category.description}
                </p>
                <span className="inline-flex items-center gap-2 font-default text-xs uppercase tracking-[0.2em] text-primary">
                  View Details
                  <ArrowRight className="size-3.5 transition-transform duration-500 ease-out group-hover:translate-x-1" strokeWidth={1.5} />
                </span>
              </div>
            </Link>)}
        </div>
      </div>
    </section>;
}